import sdk from '../../sdk';
import Logger from '../../services/Logger';

export async function getDownloadPresets() {
  Logger.log('User', 'GetDownloadPresets');

  try {
    const { data } = await sdk.downloadPresets.getAll();

    return data.downloadPresets;
  } catch (e) {
    Logger.error(new Error('Error reject get download preset list'), { error: e }, [
      'GetDownloadPresetsFailed',
      { errorMessage: (e && e.message) || 'NoMessage' },
    ]);

    throw (e);
  }
}

export async function createDownloadPreset(payload) {
  Logger.log('User', 'SaveDownloadPreset', payload);

  try {
    const { data: preset } = await sdk.downloadPresets.create(payload);

    return preset;
  } catch (e) {
    Logger.error(new Error('Error reject save download preset'), { error: e }, [
      'SaveDownloadPresetFailed',
      { errorMessage: (e && e.message) || 'NoMessage' },
    ]);

    throw e;
  }
}

export async function updateDownloadPreset(payload) {
  Logger.log('User', 'UpdateDownloadPreset', payload);

  const { _id, ...data } = payload;

  try {
    const { data: preset } = await sdk.downloadPresets.update(_id, data);

    return preset;
  } catch (e) {
    Logger.error(new Error('Error reject update download preset'), { error: e }, [
      'UpdateDownloadPresetFailed',
      { errorMessage: (e && e.message) || 'NoMessage' },
    ]);

    throw e;
  }
}

export async function deleteDownloadPreset(presetId) {
  Logger.log('User', 'DeleteDownloadPreset', presetId);

  try {
    const { data: deleted } = await sdk.downloadPresets.delete(presetId);

    return deleted;
  } catch (e) {
    Logger.error(new Error('Error reject delete download preset'), { error: e }, [
      'DeleteDownloadPresetFailed',
      { errorMessage: (e && e.message) || 'NoMessage' },
    ]);

    throw e;
  }
}
